import { memo } from 'react';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { ServiceItemCode } from 'src/models/price/productCodes';

const TrlKeys = {
    [ServiceItemCode.Anonymous]: 'employer.price2.service.entry.AP.title.1',
    [ServiceItemCode.Standart]: 'employer.price2.service.entry.VP.title.1',
    [ServiceItemCode.StandartPlus]: 'employer.price2.service.entry.RENEWAL_VP.title.1',
    [ServiceItemCode.Premium]: 'employer.price2.service.entry.VPREM.title.1',
};

interface TitleProps {
    publicationCode: ServiceItemCode | null;
}

// Пример - Анонимная ваканси
const Title: TranslatedComponent<TitleProps> = ({ publicationCode, trls }) => {
    return <span>{trls[TrlKeys[publicationCode as keyof typeof TrlKeys]]}</span>;
};

export default memo(translation(Title));
